import appGlobalScript from '/home/runner/work/scspies-website/scspies-website/styleguide/source/js/global/scspies-global.ts';
export const globalScripts = appGlobalScript;
export const globalStyles = "";
